import React, { useCallback, useEffect, useState } from 'react'
import logo from './logo.svg'
import avatarSymbol from './avatar-symbol.svg'
import shevronDownSymbol from './chevron-down-symbol.svg'
import './Header.css'
import {DropDownMenu} from '../DropDownMenu/DropDownMenu'
import * as AuthToken from '../../AuthToken'
// eslint-disable-next-line
import {AppRoutes} from '../../AppRoutes'
// eslint-disable-next-line
import { handleLogout, getParamFromState, removeTokenFromUrl, getQueryParam } from '../../utils'
import { signUpRedirect,  getUserInfo, checkTokenExpired } from '../../backendAPI'

export const Header = () => {
    const [userName, setUserName] = useState(null)
    const [showUserMenu, setShowUserMenu] = useState(false)
    const userMenuRef = React.useRef(null)

    useEffect(() => {
        const setupUserName = async () => {
            try {
                const token = getQueryParam('token')
                if (token) {
                    AuthToken.set(token)
                    removeTokenFromUrl()
                }

                const currentToken = AuthToken.get()
                if (currentToken) {
                    const tokenResponse = await checkTokenExpired(currentToken)
                    if (!tokenResponse.ok) {
                        handleLogout()
                        return
                    }
                    const userData = await getUserInfo(currentToken)
                    if (userData.name) {
                        setUserName(userData.name)
                    }
                } else {
                    signUpRedirect()
                }
            } catch (err) {
                alert(err.message)
            }
        }
        setupUserName()
    }, [])

    const handleLogoClick = () => {
        window.location.href = '/'
    }

    const handleSignUp = useCallback(() => {
        signUpRedirect()
    }, [])

    useEffect(() => {
        const handleClickOutside = event => {
          if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
            setShowUserMenu(false)
          }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
          document.removeEventListener('mousedown', handleClickOutside)
        }
      }, [])

    return (
        <div className="header-container">
            <header className="header">
                <div className="logo" onClick={handleLogoClick}>
                    <img src={logo} alt="VE Developer dashboard Logo" className="logo-img" />
                    <div className="logo-text">
                        <h1>Video Editor developers dashboard</h1>
                        <p className="sub-title">Solveig Multimedia</p>
                    </div>
                </div>
                <div className="header-buttons">
                    {!AuthToken.get() && (
                        <button className="signup-login-btn" onClick={handleSignUp}>
                            Sign Up or Login
                        </button>
                    )}
                    {AuthToken.get() && (
                        <div className="user-menu-wrapper" ref={userMenuRef}>
                            <button className="user-btn" onClick={() => setShowUserMenu(prev => !prev)}>
                                <img src={avatarSymbol} alt="" className="avatar-icon" />
                                {userName || 'Loading...'}
                                <img src={shevronDownSymbol} alt="" className="shevron-icon" />
                            </button>
                            {showUserMenu && (
                                <DropDownMenu
                                    items={[
                                        {  index: '1', label: 'Log out', onClick: handleLogout },
                                    ]}
                                />
                            )}
                        </div>
                    )}
                </div>
            </header>
        </div >
    )
}